import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/phone-black.svg")